import { useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useQuoteModal } from "../lib/quoteModal";
import { useCompareStash } from "../lib/compareStash";

/**
 * Desktop floating "Compare Offers" pill, bottom-right.
 *
 * Iter-192.F — Coordinated sticky-CTA fix. Hides when:
 *   - We're on the homepage (existing rule).
 *   - The CompareDrawer rail/expanded view is visible (items.length > 0).
 *     The drawer's z-[110] rail sits in the same bottom-right corner so
 *     this pill would overlap if both rendered.
 *
 * Mobile is handled by MobileStickyBar / MobileStickyCompareCTA (also
 * coordinated in iter-192.F to never stack).
 */
export default function StickyCTA() {
  const { pathname } = useLocation();
  const { open } = useQuoteModal();
  const { items } = useCompareStash();
  if (pathname === "/") return null;
  // Iter-192.F — Hide when CompareDrawer rail is up (same bottom-right
  // slot at higher z-index).
  if (items.length > 0) return null;
  return (
    <button
      type="button"
      onClick={() => open()}
      data-testid="sticky-cta"
      className="hidden md:inline-flex fixed bottom-6 right-6 z-40 items-center gap-2 bg-[#0A2540] hover:bg-slate-900 text-white font-bold h-12 px-5 shadow-xl shadow-slate-900/20 transition-all hover:-translate-y-1"
    >
      Compare Offers
      <ArrowRight className="w-4 h-4" />
    </button>
  );
}
